import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;
export const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;

    overflow-y: scroll;
    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #949494;
        border-radius: 4px;
    }
`;
export const HeaderConfiguration = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 3px;
    margin-top: -10px;

    span {
        margin-left: 10px;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
    }
`
export const ItemContainer = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 62px;
    box-sizing: border-box;
    padding: 10px;
    border-bottom: 1px solid #A7A7A7;
    cursor: pointer;
    ${props => props.checking && css`
        background-color: #5DBDE6;
        opacity: 0.4;
    `}
 
    span {
        margin-left: 10px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
        color: #000000;

    }
`